/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from "react";
import {FlexRow} from "../../atoms/layout/FlexRow";
import Block from "../../atoms/layout/Block";
import TextColumn from "../../molecules/products/TextColumn";

export const ModalProductHeader = ({translate, addAll}) => {
    return (
        <Block className={"ordering-modal__header-row hide-mobile"} style={FlexRow.styles.center}>
            <Block className={"row p-flex p-flex-wrap"}>
                <Block className={"p-flex col-xs-12 col-sm-5"}>
                    <Block className={"row p-flex p-flex-align-center p-flex-justify"}>
                        <TextColumn text={translate("Product")} fontSans/>
                    </Block>
                </Block>
                <Block className={"p-flex col-xs-12 col-sm-7"}>
                    <Block className={"row p-flex p-flex-wrap p-flex-justify"}>
                        <Block className={`p-flex col-xs-6 ${addAll ? "col-sm-4" : "col-sm-3"}`}>
                            <Block className={"row p-flex p-flex-align-center p-flex-justify"}>
                                <TextColumn text={translate("Unit")} fontSans className={`p-flex-justify-content-end-desktop-important`}/>
                            </Block>
                        </Block>
                        <Block className={`p-flex col-xs-6 ${addAll ? "col-sm-4" : "col-sm-3"}`}>
                            <Block className={"row p-flex p-flex-align-center p-flex-justify"}>
                                <TextColumn text={translate("Unit price")} fontSans className={`p-flex-justify-content-end-desktop-important`}/>
                            </Block>
                        </Block>
                        <Block className={`p-flex col-xs-6 ${addAll ? "col-sm-4" : "col-sm-3"}`}>
                            <Block className={"row p-flex p-flex-align-center p-flex-justify"}>
                                <TextColumn text={translate("Quantity")} fontSans className={`p-flex-justify-content-end-desktop-important`}/>
                            </Block>
                        </Block>
                    </Block>
                </Block>
            </Block>
        </Block>
    )
};
